if ($('.type-category').length) {

  $(document).ready(function () {
    showMore();
    customCatLinks();
    customSorting();
    updateSupportStatus();
    customFilter();
  })
  document.addEventListener('ShoptetDOMPageContentLoaded', function () {
    showMore();
    customCatLinks();
    customSorting(); 
    updateSupportStatus();
    customFilter();
  });
  document.addEventListener('ShoptetDOMContentLoaded', function () {
    updateSupportStatus();


  });
  
  document.addEventListener('ShoptetPageSortingChanged', function () {
    showMore();
    customCatLinks();
    customSorting();
    customFilter(); 
    updateSupportStatus();
  });
  document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
    showMore();
    customCatLinks();
    customSorting();
    customFilter(); 
    updateSupportStatus();
  });
}




function showMore() {
  var $marker = $('p:contains("#show#")');
  if (!$marker.length) return;
  var $prevParagraph = $marker.prev('p');
  var $contentAfter = $marker.nextAll();
  $contentAfter.hide();
  var $button = $('<button>', {
    class: 'show-more',
    text: translation('cistVice')
  });
  $prevParagraph.after($button);
  $marker.remove();
  $('body').off('click', '.show-more, .show-less');

  $('body').on('click', '.show-more, .show-less', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var $hiddenContent = $btn.closest('p').nextAll();
    if ($hiddenContent.is(':visible')) {
      $hiddenContent.slideUp(450);
      $btn
        .removeClass('show-less')
        .addClass('show-more')
        .text(translation('cistVice'));
    } else {
      $hiddenContent.slideDown(450);
      $btn
        .removeClass('show-more')
        .addClass('show-less')
        .text(translation('cistMene'));
    }
  });
}


function customSorting() {
  if (!$('#category-header .filters-unveil-button-wrapper').length) {
    $('#category-header').append($('.filters-unveil-button-wrapper').clone());
  }
  if (!$('#category-header .customSorting').length) {
    var currentSortText = $('#category-header .listSorting__controls li button.listSorting__control--current').text();
    $('#category-header').append('<span class="customSorting">'+(currentSortText || translation('raditDle'))+'</span>');
  }
}

$('html').on('click', '.customSorting', function () {
  $(this).closest('#category-header').find('.listSorting').toggleClass('showSorting');
});


function customFilter() {
  if (!$('.filter-section-boolean h4').length) {
    $('.filter-section-boolean .param-filter-top').before('<h4>' + translation('dleStitku') + '</h4>');
  }
  $('.slider-wrapper').addClass('filter-section');
  $('.filter-section').each(function () {

    const $section = $(this);


    /* =========================
       2️⃣ SEARCHABLE dle class
    ========================= */

    Object.keys(FILTER_SEARCHABLE_CLASSES).forEach(function (sectionClass) {

      if (!$section.hasClass(sectionClass)) return;

      const placeholderText = FILTER_SEARCHABLE_CLASSES[sectionClass];

      if (!$section.find('.filterSearchBox').length) {

        const $searchWrapper = $('<div>', {
          class: 'filterSearchWrapper'
        });

        const $search = $('<div>', {
          class: 'filterSearchBox',
          contenteditable: true,
          'data-placeholder': placeholderText
        });

        $searchWrapper.append($search);
        $section.find('form').prepend($searchWrapper);

        $search.on('input', function () {

          const value = $(this).text().trim().toLowerCase();

          $section.find('label.filter-label').each(function () {

            const text = $(this)
              .clone()
              .children()
              .remove()
              .end()
              .text()
              .trim()
              .toLowerCase();

            $(this).closest('div').toggle(text.includes(value));

          });

        });

      }

    });


    /* =========================
       3️⃣ SHOW MORE dle class
    ========================= */

    Object.keys(FILTER_SHOWMORE_CLASSES).forEach(function (sectionClass) {

      if (!$section.hasClass(sectionClass)) return;

      const limit = FILTER_SHOWMORE_CLASSES[sectionClass];

      const $items = $section
        .find('input[type="checkbox"]')
        .closest('div')
        .not('.advanced-filters-wrapper');

      if ($items.length <= limit) return;

      let expanded = false;

      function applyLimit() {

        if (!expanded) {
          $items.hide().slice(0, limit).show();
        } else {
          $items.show();
        }

      }

      applyLimit();

      if (!$section.find('.filterShowMore').length) {

        const $btn = $('<button>', {
          type: 'button',
          class: 'filterShowMore more',
          text: translation('rozbalitVse')
        });

        $section.data('expanded', expanded);

$btn.on('click', function () {

  expanded = !$section.data('expanded');
  $section.data('expanded', expanded);

  applyLimit();

  if (expanded) {
    $btn
      .removeClass('more')
      .addClass('less')
      .text(translation('rozbalitMene'));
  } else {
    $btn
      .removeClass('less')
      .addClass('more')
      .text(translation('rozbalitVse'));
  }

});

        $section.append($btn);

      }

    });

    /* =========================
   1️⃣ BANNER dle class
========================= */

    Object.keys(FILTER_BANNER_CLASSES).forEach(function (sectionClass) {

      if ($section.hasClass(sectionClass)) {

        const config = FILTER_BANNER_CLASSES[sectionClass];

        if (!$section.find('.filterCustomBanner').length) {

          const $banner = $(`
            <div class="filterCustomBanner">
              <a href="${config.url}" class="filterBannerLink" target="_blank">
                ${config.title}
              </a>
            </div>
          `);

          $section.append($banner);
        }

      }

    });


    /* =========================
       4️⃣ OPEN dle class
    ========================= */

    FILTER_OPEN_CLASSES.forEach(function (sectionClass) {

      if ($section.hasClass(sectionClass)) {
        $section.addClass('openFilter');
      }

    });


    /* =========================
       5️⃣ TOGGLE
    ========================= */

    $section.find('h4').off('click').on('click', function () {
      $section.toggleClass('openFilter');
    });

  });

}


if ($('.category__secondDescription').length) {
  $('.content-wrapper-in').after($('.category__secondDescription'));
  $('.category-content-wrapper .category__secondDescription').remove();
}


document.addEventListener('ShoptetPageSortingChanged', function () {
  if ($('.category__secondDescription').length) {
    $('.content-wrapper-in').after($('.category__secondDescription'));
    $('.category-content-wrapper .category__secondDescription').remove();
  }
})
if ($('.type-category, .type-detail').length) {
  $(document).ready(function () {
    loadAndRenderRelatedArticles();
  })
}


if ($('.type-category ul.subcategories').length) {
  $('.content-wrapper-in').after('<div class="subcatBottom"><h3>' + $('.category-top h1').text() + ' - ' + translation('vyberteKategorii') + '</h3><ul class="subcategories with-image">' + $('.type-category ul.subcategories').html() + '</ul></div>');
}

function getScrapeUrl() {

    // 👉 CATEGORY PAGE
    if ($('body.type-category').length) {
        const path = normalizePath(document.location.pathname);
        return CATEGORY_SCRAPE_MAP[path] ?? null;
    }

    // 👉 DETAIL PAGE
    if ($('body.type-detail').length) {

        // 👉 předposlední breadcrumb (kategorie)
        let rawPath = $('.breadcrumbs > span:nth-last-child(2) a').attr('href');

        if (rawPath) {
            const path = normalizePath(rawPath);

            if (CATEGORY_SCRAPE_MAP[path]) {
                return CATEGORY_SCRAPE_MAP[path];
            }
        }

        // 👉 fallback na hlavní kategorii
        const fallbackPath = normalizePath($('.breadcrumbs #navigation-1 > a').attr('href'));

        return CATEGORY_SCRAPE_MAP[fallbackPath] ?? null;
    }

    return null;
}

function normalizePath(url) {
    if (!url) return null;
    return url
        .replace(/^https?:\/\/[^/]+/, '')
        .replace(/^\/\/[^/]+/, '');
}

function loadAndRenderRelatedArticles() {
  const scrapeUrl = getScrapeUrl();
  if (!scrapeUrl) return;
  $.get(scrapeUrl, function (response) {
    const $doc = $('<div>').html(response);
    const $posts = $doc.find('.relatedPost');
    if (!$posts.length) return;
    const articles = [];
    $posts.each(function () {
      const $post = $(this);
      const $img = $post.find('.related-image img');
      const $link = $post.find('.related-title a');
      const $meta = $post.find('.related-meta');

      if (!$img.length || !$link.length) return;

      articles.push({
        image: $img.attr('src'),
        title: $.trim($link.text()),
        url: $link.attr('href'),
        readingTime: $meta.length
          ? $.trim($meta.text().replace('⏱', ''))
          : ''
      });
    });
    renderRelatedArticles(articles);
  }).fail(function () {
    console.error('Chyba při načítání článků');
  });
}


function renderRelatedArticles(articles) {

  if (!articles.length) return;

  // zabránění duplikaci
  if ($('.generated-related-articles').length) return;

  let articlesHTML = `
        <div class="generated-related-articles">
            <h2>${translation('clankyKat')}</h2>
            <div class="related-grid">
    `;

  $.each(articles, function (i, article) {

    articlesHTML += `
            <a href="${article.url}" class="related-item">
                <div class="related-image">
                    <img src="${article.image}" alt="${article.title}" loading="lazy">
                </div>
                <div class="related-content">
                    <div class="related-title">${article.title}</div>
                    <div class="related-meta">${article.readingTime}</div>
                </div>
            </a>
        `;

  });

  articlesHTML += `
            </div>
        </div>
    `;

  $('.type-category .content-wrapper-in').after(articlesHTML);
  $('.type-detail #ratingTab').before(articlesHTML);

}


function customCategory() {
  
  var totalProducts = parseFloat($('.itemsTotal strong').text().trim());
  var pageProductsCount = $('.products-page .product').length;
  var percent = 0;
  if (totalProducts > 0) {
    percent = Math.round((pageProductsCount / totalProducts) * 100);
  };
  $('.itemTotalCount').remove();
  $('.itemsTotal').after('<div class="itemTotalCount"><p>' + translation('zobrazeno') + ' ' + pageProductsCount + ' ' + translation('z') + ' ' + sklonujProdukt(totalProducts) + '</p><span class="line"><span style="width:' + percent + '%;"></span></span></div>');
  $('a.pagination__link--prev').text(translation('predchozi')).closest('li').addClass('prev')
  $('a.pagination__link--next').text(translation('dalsi')).closest('li').addClass('next')
}

$(document).ready(function () {
  customCategory();
})
document.addEventListener('ShoptetDOMPageContentLoaded', function () {
  customCategory();
});
document.addEventListener('ShoptetPageSortingChanged', function () {
  customCategory();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
  customCategory();
});

function sklonujProdukt(totalProducts) {
  totalProducts = parseInt(totalProducts, 10) || 0;

  if (totalProducts === 1) {
    return `${totalProducts} ${translation('produkt')}`;
  } else if (totalProducts >= 2 && totalProducts <= 4) {
    return `${totalProducts} ${translation('produkty')}`;
  } else {
    return `${totalProducts} ${translation('produktu')}`;
  }
}

$(".helpSidebar ul").append(
  $("footer#footer .contact-box span.tel").closest("li").clone(),
  $("footer#footer .contact-box span.mail").closest("li").clone(),
);

function customCatLinks(){
  if(!$('.category-perex .blogPosts').length){
    $('.category-perex').addClass('notRight')
  }
}
